export enum BadRequestError {
	NotMatchPreviousPassword = 'Must not match the previous password',
	EmailUsernameMismatchError = 'The provided email does not match the username entered. Please check your details and try again.',
	AccountDeactivated = 'Your account is deactivated. Please get in touch with Admin for details',
	InvalidCurrentPassword = 'Entered password does not match current password. Try again.',
}
